import styled from 'styled-components';

import UnstyledButton from 'components/unstyled-button';
import { primitive } from 'styles/constants/primitives';

import { BackButtonTextFontFamily } from './theme';

export const StyledIcon = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: ${primitive.$spacing3};
`;

export const BackButtonButton = styled(UnstyledButton)`
  display: inline-flex;
  align-items: center;
`;

export const BackButtonText = styled.span`
  font-size: 1.125rem;
  font-family: ${BackButtonTextFontFamily};
  text-transform: uppercase;
`;
